import React, { useEffect, useState } from 'react';
import { Skeleton } from '@fuxi/eevee-ui';
import { useAsyncEffect } from '@fuxi/eevee-hooks';
import DOMpurify from 'dompurify';
// App 端不支持 responseType 为 arraybuffer 的请求，需放云端
import cx from './index.module.css';

interface ProtocolReaderProps {
  url: string;
}

export const ProtocolReader: React.FC<ProtocolReaderProps> = ({ url }) => {
  const [docx, setDocx] = useState('');
  const [loading, setLoading] = useState(true);

  useAsyncEffect(async () => {
    if (!url) return;
    setLoading(true);
    try {
      const mammoth = await import('mammoth/mammoth.browser.min.js');
      const res = await fetch(url);
      const data = await res.arrayBuffer();
      const docxRes = await mammoth.convertToHtml({ arrayBuffer: data }, { includeDefaultStyleMap: true });
      const docEl = document.createElement('div');
      docEl.className = cx('document-container');
      docEl.innerHTML = docxRes.value;
      setDocx(docEl.outerHTML);
    } catch (error) {}
    setLoading(false);

    // import('mammoth/mammoth.browser.min.js').then(mammoth => {
    //   const jsonFile = new XMLHttpRequest();

    //   jsonFile.open('GET', url, true);
    //   jsonFile.send();
    //   jsonFile.responseType = 'arraybuffer';
    //   jsonFile.onreadystatechange = () => {
    //     if (jsonFile.readyState === 4 && jsonFile.status === 200) {
    //       mammoth
    //         .convertToHtml({ arrayBuffer: jsonFile.response }, { includeDefaultStyleMap: true })
    //         .then((result: any) => {
    //           const docEl = document.createElement('div');
    //           docEl.className = cx('document-container');
    //           docEl.innerHTML = result.value;
    //           setDocx(docEl.outerHTML);
    //         })
    //         .catch(() => {});
    //     }
    //   };
    // });
  }, [url]);

  return loading ? (
    <Skeleton />
  ) : (
    <div className={cx('viewer')} dangerouslySetInnerHTML={{ __html: DOMpurify.sanitize(docx) }} />
  );
};

export default ProtocolReader;
